import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { VisitorsService } from './service/visitors.service';

@Component({
    selector: 'app-newsletter-input',
    templateUrl: './newsletter-input.component.html',
    styleUrls: ['./newsletter-input.component.scss'],
    standalone: false
})
export class NewsletterInputComponent {
  emailForm: FormGroup;
  success: boolean = false;
  constructor(
    private visitorsService: VisitorsService
  ) {
    this.emailForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email, Validators.minLength(6)]),
    });
  }

  get email() {
    return this.emailForm.get('email') as FormControl;
  }

  onSubmit() {
    try {
      if (this.emailForm.valid) {
        this.success = false;
        this.visitorsService.createVisitor(this.email.value).then(() => {
          this.emailForm.reset();
          this.success = true;
          setInterval(() => {
            this.success = false
          }, 10000);
        });
      } else {
        this.email.markAsTouched();
      }
    } catch (error) {

    }
  }
}
